export enum RecordingState {
  Ready = 'READY',
  Progress = 'PROGRESS',
  Paused = 'PAUSED',
  Stop = 'STOP'
}
